import { duplicatePreset, removePreset } from '../../../api';
import getNameForPreset from '../../../helpers/getNameForPreset';
import { controllingSetDefaultPreset } from '../../../store/controlling/actions';
import { presetsSet } from '../../../store/presets/actions';
import { loadPresets } from '../../App/hooks/useLoadPresets';
import Confirm from '../../Confirm';
import Back from '../Back';
import Content from '../Content';
import styles from '../common/DevTools.module.scss';
import shouldBeSelected from '../helpers/shouldBeSelected';
import useDevTools from '../hooks/useDevTools';
import localStyles from './PresetList.module.scss';
import menuSvg from './assets/menu.svg';
import cn from 'classnames';
import React, { useMemo, useState } from 'react';
import toast from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';

const types = {
  rag: 'rag',
  sobol: 'sobol',
  hog: 'hog',
  chalk: 'chalk',
};

const Element = ({ item, selectedBrush, open, options, menu }) => {
  const [openMenuId, setShowMenu] = options;
  const [confirmRemove, setConfirmRemove] = useState(false);
  const dispatch = useDispatch();

  const duplicate = async () => {
    try {
      const response = await duplicatePreset(item.id);
      const name = response.data.newFileName;

      toast.success(`Preset duplicated as ${name}.`);

      const presets = await loadPresets();
      dispatch(presetsSet(presets));
    } catch (e) {
      toast.error('Something went wrong');
    }
  };

  const remove = async () => {
    try {
      await removePreset(item.id);

      const currentUrl = window.location.href;
      window.location.href = currentUrl;
    } catch (e) {
      toast.error('Something went wrong');
    }
  };

  return (
    <li key={item.id} className={cn(shouldBeSelected(item.id, menu, 0) && styles.selected)}>
      <div
        className={cn(styles.name, localStyles.name)}
        onClick={() => {
          open(1, 'preset-details', {
            id: item.id,
            menuIndex: 1,
            name: item.id,
          });
        }}
      >
        <div className={styles.icon}>
          <img src={`/images/${item.type}.svg`} alt={item.name} />
        </div>
        <span>
          {Array.isArray(item.name) ? (
            <>
              {item.name[0]} <em>{item.name[1]}</em>
            </>
          ) : (
            item.name
          )}
        </span>
      </div>
      <div className={localStyles.right}>
        <div
          onClick={() => {
            dispatch(controllingSetDefaultPreset(item.type, item.id));
          }}
          className={cn(localStyles.checkbox, selectedBrush === item.id && localStyles.checked)}
        />

        <img
          src={menuSvg}
          className={localStyles.menuButton}
          alt="Menu"
          onClick={() => {
            setShowMenu(item.id);
          }}
        />
      </div>

      {openMenuId === item.id && (
        <div className={localStyles.menu}>
          <span onClick={duplicate}>Duplicate</span>
          {item.editable && (
            <span
              onClick={() => {
                setConfirmRemove(true);
              }}
            >
              Remove
            </span>
          )}
          <button
            onClick={() => {
              setShowMenu(undefined);
            }}
          ></button>
        </div>
      )}

      {confirmRemove && (
        <Confirm
          text={`Do you want to remove preset ${item.id}? App will be reloaded.`}
          handleNo={() => {
            setConfirmRemove(false);
          }}
          handleYes={() => {
            remove();
          }}
        />
      )}
    </li>
  );
};

const PresetList = () => {
  const { setMenu, menu } = useDevTools();
  const presets = useSelector((state) => state.presets);
  const selectedBrush = useSelector((state) => state.controlling.defaultPresets[state.controlling.presetType]);
  const options = useState(undefined);

  const data = useMemo(() => {
    return Object.entries(presets).map((entry) => ({
      name: getNameForPreset(entry),
      id: entry[0],
      type: types[entry[0].substring(0, entry[0].indexOf('-'))] || 'custom',
      editable: entry[1].editable,
    }));
  }, [presets]);

  return (
    <>
      <Back title={'Presets'} />
      <Content>
        <ul className={styles.list}>
          {data.map((item) => (
            <Element menu={menu} item={item} open={setMenu} options={options} selectedBrush={selectedBrush} />
          ))}
        </ul>
      </Content>
    </>
  );
};

export default PresetList;
